import { $http } from '@/utils';

/**
 * @namespace Service
 * @class WriteRoute
 * @exports Service/App/Matter/WriteRouteTemplate
 * @description API App Matter WriteRouteTemplate Service
 * @date 2024/09/30
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class WriteRouteTemplate {
	/**
	 * @static @name list
	 * @description Get all fact find templates
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static async list(payload) {
		return $http.post('write-route/template/list', payload);
	}

	/**
	 * @static @name create
	 * @description Create a fact find template
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static async create(payload) {
		return $http.post('write-route/template', payload);
	}

	/**
	 * @static @name modify
	 * @description Modify a fact find template
	 * @param {String} id
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static async modify(id, payload) {
		return $http.patch(`write-route/template/${id}`, payload);
	}

	/**
	 * @static @name delete
	 * @description Delete a fact find template
	 * @param {String} id
	 * @returns {Object} Promise a http response
	 */
	static async delete(id) {
		return $http.delete(`write-route/template/${id}`);
	}
}
